export interface RNMachineRepairUserRef {
  _id?: string;
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
}

export interface RNMachineRepair {
  subprocessId: string;
  machineId: string;
  repairText: string;
  repairDate: string;
  repairBy: string;
  approved: boolean;
  approvedBy?: RNMachineRepairUserRef | null;
  approvedByName?: string;
  approvedAt?: string | null;
}

export type RNMachineRepairField = 'repairText' | 'repairDate' | 'repairBy';

export const machineRepairKey = (subprocessId: string, machineId: string) => `${subprocessId}:${machineId}`;

const displayDate = (value: unknown) => {
  const text = String(value ?? '').trim();
  const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return iso ? `${iso[3]}.${iso[2]}.${iso[1]}` : text;
};

export const normalizeRNMachineRepairs = (repairs: RNMachineRepair[] | undefined): RNMachineRepair[] =>
  (repairs || [])
    .filter((repair) => repair?.subprocessId && repair?.machineId)
    .map((repair) => ({
      subprocessId: repair.subprocessId,
      machineId: repair.machineId,
      repairText: repair.repairText || '',
      repairDate: displayDate(repair.repairDate),
      repairBy: repair.repairBy || '',
      approved: !!repair.approved,
      approvedBy: repair.approvedBy || null,
      approvedByName: repair.approvedByName || '',
      approvedAt: repair.approvedAt || null,
    }));

// A row with no repair text/date/author AND not approved carries nothing worth
// persisting — dropping it here is also how a user "deletes" a row: clearing all
// three fields (and leaving it unapproved) removes it from the next save.
export const toRNMachineRepairsPayload = (repairs: RNMachineRepair[]) =>
  normalizeRNMachineRepairs(repairs)
    .filter((repair) => repair.approved || !!(repair.repairText.trim() || repair.repairDate.trim() || repair.repairBy.trim()))
    .map(({ subprocessId, machineId, repairText, repairDate, repairBy, approved }) => ({
      subprocessId,
      machineId,
      repairText,
      repairDate,
      repairBy,
      approved,
    }));
